module.exports = __webpack_public_path__ + "img/main_3_3_2.7676887f.png";